import React from 'react';
import { css } from 'linaria';
import classNames from 'classnames';
import { buttonReset } from 'components/buttons/button-reset';
import { CrossIcon } from '@pocket/web-ui';
export const tagBase = "trxac13";
export const tagWrapper = "t9ef2pv";
const closeWrapper = "cn6urtm";
export class Tag extends React.Component {
  constructor(props) {
    super(props);

    this.removeClick = () => {
      const {
        removeClick,
        children
      } = props;
      if (removeClick) removeClick(children);
    };

    this.selectClick = () => {
      const {
        selectClick,
        children
      } = props;
      if (selectClick) selectClick(children);
    };
  }

  render() {
    const {
      children,
      removeClick,
      selected,
      action,
      margin
    } = this.props;
    return <div className={classNames(tagBase, tagWrapper, {
      action,
      selected
    })} style={{
      margin
    }} onClick={this.selectClick}>
        {children}
        {removeClick ? <button className={classNames(buttonReset, closeWrapper, {
        selected
      })} onClick={this.removeClick}>
            <CrossIcon />
          </button> : null}
      </div>;
  }

}

require("./tag.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./tag.js");